import React, { lazy, Suspense } from 'react';

const LazyCookiesModal = lazy(() => import('./CookiesModal'));

const CookiesModal = props => (
  <Suspense fallback={null}>
    <LazyCookiesModal {...props} />
  </Suspense>
);

export default CookiesModal;
